<script setup lang="ts">
import { LocaleLink } from '#components'

/**
 * Marketing button: pill shape with the label-swap hover from the template.
 *
 * The label is rendered twice on purpose — the first copy slides out on hover
 * while the second slides in. Renders a real anchor when `to` is set.
 */
const props = withDefaults(defineProps<{
  label: string
  to?: string
  variant?: 'accent' | 'dark' | 'outline' | 'light'
  disabled?: boolean
  block?: boolean
  /** Only for the button form; `submit` lets the pill sit inside a <form>. */
  type?: 'button' | 'submit'
}>(), {
  variant: 'accent',
  type: 'button',
})

const asLink = computed(() => !!props.to && !props.disabled)
</script>

<template>
  <component
    :is="asLink ? LocaleLink : 'button'"
    :to="asLink ? props.to : undefined"
    :type="asLink ? undefined : props.type"
    :disabled="asLink ? undefined : props.disabled"
    class="btn"
    :class="[`btn-${variant}`, { 'w-full': block, 'cursor-not-allowed opacity-60': disabled }]"
  >
    <span>{{ label }}</span>
    <span aria-hidden="true">{{ label }}</span>
  </component>
</template>
